import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const heroImages = [
    `${window._env_.STATIC_HOST}/static/website/images/BENEFICIOS.webp`,
    `${window._env_.STATIC_HOST}/static/website/images/PUNTOS.webp`,
];

export const Hero = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        // fade: true,
        cssEase: 'ease-in-out',
        arrows: false,
    };

    return (
        <Slider {...settings} className="header-benefits-slider">
            {heroImages.map((image, index) => (
                <div key={index}>
                    <section
                        className='header-regular header-benefits'
                        style={{
                            backgroundImage: `url("${image}")`,
                        }}>
                        {/* <div className='main-container'>
                            <div>
                                <h3>Beneficios Toyota</h3>
                                <p>
                                    Descubre los descuentos y beneficios que puedes obtener
                                    usando la aplicación Mundo Toyota.
                                </p>
                            </div>
                        </div> */}
                    </section>
                </div>
            ))}
        </Slider>
    );
};
